<template>
<div class="content second-plan">
  <spinner :active="professionalsLoading" />
  <div v-if="MARMode" class="breadcrumb first-plan" >
      <!-- PDF -->
      <div  @blur="pdfDropDown=false;" class="bt-pdf">
        <div>
          <spinner :active="downloadPdfInProgress" />
          <a @click="downloadIfNoSelectionElseShowMenu();" class="bc-pdf bc-title">Télécharger en pdf<font-awesome-icon icon="chevron-circle-down"/></a>
          <div v-show="pdfDropDown" class="bc-dropdown bc-dropdown-pdf pdf-menu">
            <a @click="pdfDropDown=false;downloadType='all';showModalComment();" class="bc-dropdown-element">Tous les professionnels</a>
            <a v-if="favoritePro && favoritePro.length" @click="pdfDropDown=false;downloadType='selection';showModalComment();" class="bc-dropdown-element">La sélection uniquement</a>
          </div>
        </div>
      </div>


    <a @click="goHome" title="Modifier la recherche"><font-awesome-icon icon="home"/> Modifier la recherche</a>
  </div>
  <div class="content result-container">
    <div class="result-cards" v-show="!fullscreenMap">
      <liste-results
        :professionals="filteredProfessionals"
        :allMode="true"
        @locate-professional="setFocusOnProfessional"
        />
    </div>
    <div :class="{ 'result-map': !fullscreenMap, 'result-map-fullscreen': fullscreenMap }">
      <liste-results-map
        class="map-object"
        :focusOnProfessional="focusOnProfessional"
        :professionals="filteredProfessionals"
        @resize-map="resizeMap"
        />
        
    </div>
  </div>

  <DialogWrapper
    ref="modalHelpResult"
  >
    <div> 
      <help-search
        @hide-modal="hideModalHelpResult"
        >
      </help-search>
    </div>
  </DialogWrapper>
  
  <DialogWrapper
    ref="modalComment"
    :adaptive="false"
    :width="1000"
    height="auto"
    clickToClose
    :scrollable="true"
    >   
    <div> 
      <modal-comment
        @hide-modal="hideModalComment"
        @start-download="startDownload"
        >
      </modal-comment>
    </div>
  </DialogWrapper>
  
  
</div>
</template>

<script>
import apiClient from '@/api/api';

import Spinner from '@/components/spinner';
import ListeResults from '@/apps/listepro/public/search/liste_results';
import ListeResultsMap from '@/apps/listepro/public/search/liste_results_map';
import ModalComment from '@/apps/listepro/public/search/modal_comment';
import { downloadPdf } from "@/helpers/pdf";

import { sync } from 'vuex-pathify';

export default {
    name: 'ListeAll',
    props: {
        MARMode: { default: false, type: Boolean },
    },
    data() {
        return {
            professionalsLoading: false,
            professionals: [],
            focusOnProfessional: null,
            fullscreenMap: false,
            pdfDropDown: false,
            downloadType:"",
            downloadPdfInProgress: false,
        };
    },
    provide() {
        return { parentValidator: this.$validator };
    },
    components: {
        ListeResults,
        ListeResultsMap,
        Spinner,
        ModalComment,
    },
    computed: {
        filteredProfessionals() {
            if (this.MARMode) {
                return this.professionals.filter(x => x.isMonAccompagnateurRenov === true);
            }
            return this.professionals;
        },
        favoritePro: sync("listepro/favoritePro"),
        downloadAll: sync("listepro/downloadAll"),
        commentPdf: sync("listepro/commentPdf"),
        whiteLabelling: sync("whiteLabelling"),
    },
    mounted: function() {
        this.loadProfessionals();
    },
    watch: {
    },
    methods: {
        goHome() {
            this.$router.push({ name: 'ListeProPublicSearch' });
        },
        loadProfessionals() {
            this.professionalsLoading = true;
            apiClient.genericList(`/listepro/public/professional/`)
                .then(response => {
                    this.professionals = response;
                })
                .catch(error => {
                    console.debug(error);
                    this.$notify({
                        group: 'root',
                        type: 'error',
                        title: 'Erreur serveur',
                        text: 'La liste des professionnels n\'a pas pu être chargée.',
                    });
                })
                .finally( () => {
                    this.professionalsLoading = false;
                });
            
        },
        resizeMap(fullscreen) {
            this.fullscreenMap = fullscreen;
        },
        
        setFocusOnProfessional(professionalPk) {
            this.focusOnProfessional = null;
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.focusOnProfessional = professionalPk;
                });
            });
        },
        showModalHelpResult() {
            this.$refs.modalHelpResult.show();
        },
        hideModalHelpResult() {
            this.$refs.modalHelpResult.hide();
        },
        showModalComment() {
            this.commentPdf="";
            this.$refs.modalComment.show();
        },
        hideModalComment() {
            this.$refs.modalComment.hide();
        },
        downloadPdf() {
            this.downloadPdfInProgress = true;

            const data = {
                mission: this.mission,
                subMission: this.subMission,
                activity: this.activity,
                favoritePro: [],
                commentPdf: this.commentPdf,
                downloadAll: this.downloadAll,
            };

            if (this.downloadAll === 'selection') {
                data.favoritePro = this.professionals.filter(x => this.favoritePro.includes(x.pk));
            } else {
                // fake a selection
                data.favoritePro = this.filteredProfessionals;
                data.downloadAll = 'selection';
            }

            apiClient
                .getListeProPdf({
                    data: data,
                    domain: this.whiteLabelling.domain,
                })
                .then(response => {
                    downloadPdf(response, "rapport-liste-professionnels.pdf");
                    this.downloadAll="nothing";
                    this.commentPdf="";
                })
                .catch(error => {
                    this.handleFormErrors(error);
                })
                .finally(() => {             
                    this.downloadPdfInProgress = false;
                });
        },
        startDownload() {
            this.hideModalComment();
            this.downloadAll=this.downloadType;
            this.downloadPdf();
        },
        downloadIfNoSelectionElseShowMenu() {
            console.log(this.favoritePro && this.favoritePro.length, this.favoritePro, this.favoritePro.length);
            if (this.favoritePro && this.favoritePro.length) {
                this.pdfDropDown = !this.pdfDropDown;
                this.downloadType = 'nothing';
            } else {
                this.downloadType = 'all';
                this.showModalComment();
            }
        },
    },
};
</script>

<style lang="stylus" scoped>
@require '../../../stylesheet/variables'
@require '../../../stylesheet/typography'

.breadcrumb
    margin-left: 32px

.breadcrumb
    padding-bottom: 0.7rem
    padding-top: 0.7rem
    margin-bottom: 0rem
    background-color: gray-100
    position: relative
    display: grid

    .bt-menu
        grid-row: 1
        grid-column: 1 -3
        min-width: 300px

        ul
            list-style-type: none

    .bt-pdf
        grid-row: 1
        grid-column: 4
        text-align: right
        margin-right: 2rem
        margin-top: -5px

    .bc-dropdown
        position: absolute

    .bc-dropdown.pdf-menu
        right: 0rem

.bc-title
    color: black

.bc-pdf
    text-transform: uppercase
    font-size: 0.6875rem

.bc-title:hover
    color: primary-color-500
    text-decoration: none

.bc-dropdown
    padding: 1px
    background: #fff
    border: 1px solid gray-500

.bc-dropdown-pdf
    width: 10rem

a.bc-dropdown-element
    display: block
    padding: 0.3rem 1rem 0.3rem 0.3rem
    text-transform: none
    font-size: 0.8rem

a.bc-dropdown-element:hover
    background-color: gray-200
    color: #000
    text-decoration: none

.first-plan
    z-index: 1000

.second-plan
    z-index: 1

.result-container
    padding: 0 space-md 0 space-md
    // background-color: red !important
    display: grid
    grid-template-columns: minmax(365px, 780px) auto
    grid-gap: 20px

    .result-cards
        padding-top: 27px
        padding-bottom: space-xl
        grid-column: 1
        grid-row: 1
        // min-width: 362px
        // width: 362px

    .result-map
        height: 100%
        grid-column: 2
        grid-row: 1

        :deep(.liste-results-map)
            position: sticky
            top: 0

    .result-map-fullscreen
        height: 100%
        grid-column: 1 / 3
        grid-row: 1

    @media (max-width: 600px)
        .result-map
            display: none

.content
    background-color: gray-100
    padding-top: 0.5rem
</style>
